import React from 'react';
import './App.css';
import Login from './components/auth/Login';
import { Toaster } from 'react-hot-toast';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import PowerBiIframe from './components/iframe/PowerBiIframe';
import Header from './components/appComponents/Header';
import Main from './components/appComponents/Main';
//import UserManagement from './components/admin/UserManagement';
//import BrandManagement from './components/admin/BrandManagement';
import UserManagement from './components/userManagement/UserManagement';

import BrandManagement from "./components/brandManagement/BrandManagement";
import BrandList from './components/brandManagement/BrandList';
import OnBoarding from './components/onBoarding/OnBoarding';
import Category from './components/onBoarding/Category';
import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the grid
import "ag-grid-community/styles/ag-theme-quartz.css"; // Optional Theme applied to the grid
import Keyword from './components/onBoarding/Keyword';
import Product from './components/onBoarding/Product';
import CategoryMapping from './components/onBoarding/CategoryMapping';
import Crawl from './components/onBoarding/Crawl';
import ViewCategory from './components/onBoarding/ViewCategory';
import { Provider } from 'react-redux';
import store from "./redux/store";
import Campaign from './components/onBoarding/Campaign';
import ParentChildMapping from './components/onBoarding/ParentChildMapping';
import AccountSetting from './components/onBoarding/AccountSetting';
import FavoriteSelection from './components/onBoarding/FavoriteSelection';
import CreatePassword from './components/auth/CreatePassword';
import ViewKeyword from './components/onBoarding/ViewKeyword';
import ManualOnBoarding from './components/manualOnBoarding/ManualOnBoarding';
import PreparingDashboard from './components/utils/PreparingDashboard';
import UnmappedData from './components/unmappedData/UnmappedData';
import ProductMaster from './components/unmappedData/ProductMaster';
import CampaignMaster from './components/unmappedData/CampaignMaster';
import KeywordMaster from './components/unmappedData/KeywordMaster';
import PowerBi from './components/powerbi/PowerBi';
import BulkUpload from './components/bulkUpload/BulkUpload';
import LatestFiles from './components/bulkUpload/LatestFiles';
import AllFiles from './components/bulkUpload/AllFiles';
import GroupKeyword from './components/groupKeyword/GroupKeyword';
import BrandDetailView from './components/brandManagement/BrandDetailView';
import BrandDetailEdit from './components/brandManagement/BrandDetailEdit';

import UserList from './components/userManagement/UserList';
import UserDetailView from "./components/userManagement/UserDetailView";

import PlatformManagement from './components/PlatformAndDashboardManagement/PlatformManagement';
import PlatformdashboardList from './components/PlatformAndDashboardManagement/PlatformdashboardList';
import UserDetailEditNew from './components/userManagement/UserDetailEditNew';
import KeywordManagement from './components/keyword/KeywordManagement';
import KeywordList from './components/keyword/KeywordList';

import CategoryManagement from './components/category/CategoryManagement';
import CategoryList from './components/category/CategoryList';
import CategoryMasterManagement from './components/categorymaster/CategoryMasterManagement';
import PrincipleCategoryMaster from './components/categorymaster/PrincipleCategoryMaster';
import MainCategoryMaster from './components/categorymaster/MainCategoryMaster';
import CatCategoryMaster from './components/categorymaster/CatCategoryMaster';
import SubCategoryMaster from './components/categorymaster/SubCategoryMaster';

import DashboardManagement from './components/Dashboard/DashboardManagement';
import Comparison from './components/Dashboard/Overview_Page/Comparison';
import Summary from './components/Dashboard/Overview_Page/Summary';
import SalesAnalysis from './components/Dashboard/Sales_Analysis_Page/SalesAnalysis';
import Ads_Dashboard_Management from './components/Ads_Dashboard/Ads_Dashboard_Management';
import SalesAnalysisComparison from './components/Ads_Dashboard/Sales_Analysis_Page/Comparison_Page/SalesAnalysisComparison';
import OverviewComparisonPage from './components/Ads_Dashboard/Overview_Page/OverviewComparisonPage';
import OverviewSummaryPage from './components/Ads_Dashboard/Overview_Page/OverviewSummaryPage';
import SalesAnalysisSummaryPage from './components/Ads_Dashboard/Sales_Analysis_Page/Summary_Page/SalesAnalysisSummaryPage';
import AdsAnalysisComparison from './components/Ads_Dashboard/Ads_Analysis_Page/Comparison_Page/AdsAnalysisComparison';
import AdsAnalysisSummaryPage from './components/Ads_Dashboard/Ads_Analysis_Page/Summary_Page/AdsAnalysisSummaryPage';
import TargetingAnalysisComparison from './components/Ads_Dashboard/Targeting_Analysis_Page/Comparison_Page/TargetingAnalysisComparison';
import TargetingAnalysisSummaryPage from './components/Ads_Dashboard/Targeting_Analysis_Page/Summary_Page/TargetingAnalysisSummaryPage';
import CSTAnalysisComparison from './components/Ads_Dashboard/CST_Analysis_Page/Comparison_Page/CSTAnalysisComparison';
import CSTAnalysisSummaryPage from './components/Ads_Dashboard/CST_Analysis_Page/Summary_Page/CSTAnalysisSummaryPage';
import PlacementAnalysisComparison from './components/Ads_Dashboard/Placement_Analysis_Page/Comparison_Page/PlacementAnalysisComparison';
import PlacementAnalysisSummaryPage from './components/Ads_Dashboard/Placement_Analysis_Page/Summary_Page/PlacementAnalysisSummaryPage';
import Drill_Through_Page from './components/Ads_Dashboard/Drill_Through_Page/Comparison_Page/Drill_Through_Page';
import Drill_Through_Summary_Page from './components/Ads_Dashboard/Drill_Through_Page/Summary_Page/Drill_Through_Summary_Page';

import Masters from './components/Masters/Mater';
import MappingPage from './components/Ads_Dashboard/Mapping_Page/MappingPage';
import CstMaster from './components/unmappedData/CstMaster';
import MapTargeting from './components/unmappedData/MapTargeting';
import TargetingMaster from './components/unmappedData/TargetingMaster';
import STRecommendation from './components/unmappedData/STRecommendation';
import MapProduct from './components/unmappedData/MapProduct';
import MapCampaign from './components/unmappedData/MapCampaign';
import ReportManagementPage from './components/reportManagement/ReportManagementPage';
import Vendor from './components/reportManagement/Vendor';

import AmazonProfileSelect from "./components/apiAccessManagement/amazon/AmazonProfileSelect";
import GiveAccess from './components/giveAccess/Amazon/GiveAccess';
import FlipkartGiveAccess from './components/giveAccess/Flipkart/FlipkartGiveAccess';
import FlipkartSeller from './components/giveAccess/Flipkart/Seller/FlipkartSeller';
import AmazonAdsAccess from './components/giveAccess/Amazon/AdsAccess/AmazonAdsAccess';
import AmazonSellerAccess from './components/giveAccess/Amazon/SellerAccess/AmazonSellerAccess';
import AmazonVendorAccess from './components/giveAccess/Amazon/VendorAccess/AmazonVendorAccess';
import FlipkartSellerAds from './components/giveAccess/Flipkart/SellerAds/FlipkartSellerAds';
import FlipkartAds from './components/giveAccess/Flipkart/Ads/FlipkartAds';

function App() {
  const router = createBrowserRouter([
    {
      path: "/",
      element: <Main />,
      children: [
        {
          path: "unmappedData",
          element: <UnmappedData />,
          children: [
            {
              path: "productMaster/:brand_id/:platform_id",
              element: <ProductMaster />,
            },
            {
              path: "product/:brand_id/:platform_id",
              element: <MapProduct />,
            },
            {
              path: "campaignMaster/:brand_id/:platform_id",
              element: <CampaignMaster />,
            },
            {
              path: "campaign/:brand_id/:platform_id",
              element: <MapCampaign />,
            },
            {
              path: "keywordMaster",
              element: <KeywordMaster />,
            },
            {
              path: "cstMaster/:brand_id/:platform_id",
              element: <CstMaster />,
            },
            {
              path: "targeting/:brand_id/:platform_id",
              element: <MapTargeting />,
            },
            {
              path: "targetingMaster/:brand_id/:platform_id",
              element: <TargetingMaster />,
            },
            {
              path:"STRecommendation/:brand_id/:platform_id",
              element: <STRecommendation />
            }
          ]
        },
        {
          path: "bulkUpload",
          element: <BulkUpload />,
          children: [
            {
              path: "latestFiles",
              element: <LatestFiles />,
            },
            {
              path: "allFiles",
              element: <AllFiles />,
            }
          ]
        },
        {
          path:"masters/:brand_id/:platform_id",
          element:<Masters/>
        },
        {
          path: "reportsUpload",
          element: <ReportManagementPage />,
          children: [
            {
              path: "vendor/:brand_id/:platform_id",
              element: <Vendor />
            }
          ]
        },
        {
          path: "groupKeyword",
          element: <GroupKeyword />
        },
        { 
          path: "dashboard",
          element: <PowerBi />
        },
        {
          path: "embeddedDashboard",
          element: <PowerBi />
        },
        {
          path: "preparingDashboard",
          element: <PreparingDashboard />
        },

        {
          path: "userManagement",
          element: <UserManagement />,
          children: [
            {
              path: "userList",
              element: <UserList />
            },
            {
              path: "userDetailView/:user_id",
              element: <UserDetailView />
            },
            // {
            //   path: "userDetailEditOld/:user_id",
            //   element: <UserDetailEditNew/>
            // },
            {
              path: "userDetailEdit/:user_id",
              element: <UserDetailEditNew />
            },
          ]
        },
        {
          path: "platformDashboardManagement",
          element: <PlatformManagement />,
          children: [
            {
              path: "platformList",
              element: <PlatformdashboardList />
            },
            {
              path: "userDetailView/:user_id",
              element: <UserDetailView />
            },
            {
              path: "userDetailEdit/:user_id",
              element: <UserDetailEditNew />
            }
          ]
        },
        {
          path: "brandManagement",
          element: <BrandManagement />,
          children: [
            {
              path: "brandList",
              element: <BrandList />
            },
            {
              path: "brandDetailView/:brand_id",
              element: <BrandDetailView />
            },
            {
              path: "brandDetailEdit/:brand_id",
              element: <BrandDetailEdit />
            }
          ]
        },
        {
          path: "keyword",
          element: <KeywordManagement />,
          children: [
            {
              path: "keywordList",
              element: <KeywordList />
            },
          ]
        },
        {
          path: "category",
          element: <CategoryManagement />,
          children: [
            {
              path: "categoryList",
              element: <CategoryList />
            },
          ]
        },
        {
          path: "categorymaster",
          element: <CategoryMasterManagement />,
          children: [
            {
              path: "principal_category/:brand_id",
              element: <PrincipleCategoryMaster />
            },
            {
              path: "main_category/:brand_id",
              element: <MainCategoryMaster />
            },
            {
              path: "category/:brand_id",
              element: <CatCategoryMaster />
            },
            {
              path: "sub_category/:brand_id",
              element: <SubCategoryMaster />
            },
          ]
        },
        {
          path: "Adsdashboard",
          element: <DashboardManagement />,
          children: [
            {
              path: "overview/comparison",
              element: <Comparison />
            },
            {
              path: "overview/summary",
              element: <Summary />
            },
            {
              path: "salesAnalysis",
              element: <SalesAnalysis />
            }
          ]
        },
        {
          path: "Ads_dashboard",
          element: <Ads_Dashboard_Management />,
          children: [
            {
              path: "overview/comparison/:brand_id",
              element: <OverviewComparisonPage />
            },
            {
              path: "overview/summary/:brand_id",
              element: <OverviewSummaryPage />
            },

            {
              path: "salesAnalysis/comparison/:brand_id",
              element: <SalesAnalysisComparison />
            },
            {
              path: "salesAnalysis/summary/:brand_id",
              element: <SalesAnalysisSummaryPage />
            },

            {
              path: "adsAnalysis/comparison/:brand_id",
              element: <AdsAnalysisComparison />
            },
            {
              path: "adsAnalysis/summary/:brand_id",
              element: <AdsAnalysisSummaryPage />
            },

            {
              path: "targetingAnalysis/comparison/:brand_id",
              element: <TargetingAnalysisComparison />
            },
            {
              path: "targetingAnalysis/summary/:brand_id",
              element: <TargetingAnalysisSummaryPage />
            },

            {
              path: "cstAnalysis/comparison/:brand_id",
              element: <CSTAnalysisComparison />
            },
            {
              path: "cstAnalysis/summary/:brand_id",
              element: <CSTAnalysisSummaryPage />
            },

            {
              path: "placementAnalysis/comparison/:brand_id",
              element: <PlacementAnalysisComparison />
            },
            {
              path: "placementAnalysis/summary/:brand_id",
              element: <PlacementAnalysisSummaryPage />
            },

            {
              path: "drill_Through/comparison/:brand_id/:data_query",
              element: <Drill_Through_Page/>
            },
            {
              path: "drill_Through/summary/:brand_id/:data_query",
              element: <Drill_Through_Summary_Page/>
            },

            {
              path: "mapping/:brand_id",
              element: <MappingPage />
            },
          ]
        },
        {
          path: "onBoardingManual",
          element: <ManualOnBoarding />
        },
        {
          path: "category",
          element: <Category />
        },
        {
          path: "viewCategory",
          element: <ViewCategory />
        },
        {
          path: "keyword",
          element: <Keyword />
        },
        {
          path: "viewKeyword",
          element: <ViewKeyword />
        },
        {
          path: "onBoarding",
          element: <OnBoarding />,
          children: [
            {
              path: "category",
              element: <Category />
            },
            {
              path: "viewCategory",
              element: <ViewCategory />
            },
            {
              path: "keyword",
              element: <Keyword />
            },
            {
              path: "viewKeyword",
              element: <ViewKeyword />
            },
            {
              path: "product",
              element: <Product />
            },
            {
              path: "categoryMapping",
              element: <CategoryMapping />
            },
            {
              path: "crawl",
              element: <Crawl />
            },
            {
              path: "campaign",
              element: <Campaign />
            },
            {
              path: "parentChildMapping",
              element: <ParentChildMapping />
            },
            {
              path: "favoriteSelection",
              element: <FavoriteSelection />
            }
          ]
        },
        {
          path: "accountSetting",
          element: <AccountSetting />
        },

        {
          path: "giveAccess",
          element: <GiveAccess/>,
          children: [
            {
              path: "ads/:brand_id",
              element: <AmazonAdsAccess/>
            },
            {
              path: "seller/:brand_id",
              element: <AmazonSellerAccess/>
            },
            {
              path: "vendor/:brand_id",
              element: <AmazonVendorAccess/>
            },
          ]
        },

        {
          path: "flipkartgiveAccess",
          element: <FlipkartGiveAccess/>,
          children: [
            {
              path: "seller/:brand_id",
              element: <FlipkartSeller/>
            },
            {
              path: "sellerAds/:brand_id",
              element: <FlipkartSellerAds/>
            },
            {
              path: "ads/:brand_id",
              element: <FlipkartAds/>
            },
          ]
        }
        
      ]
    },

    {
      path: "/amazonProfileSelect",
      element: <AmazonProfileSelect/>
    },

    {
      // brand_id added for access API Module
      path: "/login/:brand_id?/:id?",
      element: <Login />
    },
    {
      path: "/createPassword/:token",
      element: <CreatePassword />
    }
  ]);



  return (
    <>
      <Provider store={store}>

        <RouterProvider router={router} />
        <Toaster
          position="top-right"
          reverseOrder={false}
        />
      </Provider>
    </>
  );
}

export default App;


